<template>
    <section class="notenart-detail">
        <template v-if="busy">
            <CenteredMessage spinner="true">Daten werden geladen</CenteredMessage>
        </template>
        <template v-else>
            <b-table-simple class="table-plain inner-table" responsive small bordered>
                <b-thead>
                    <b-tr>
                        <b-th>Art</b-th>
                        <b-th class="table-danger">Ausgegeben</b-th>
                        <b-th class="table-success">Restbestand</b-th>
                        <b-th>Gesamtbestand</b-th>
                        <b-th>Archiv-Nr.</b-th>
                        <b-th>Preis pro Note</b-th>
                        <b-th class="text-center">Geliehen</b-th>
                        <b-th>Geliehen von</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="item in items" :key="item.id">
                        <b-th>{{item.description}}</b-th>
                        <b-td class="text-right table-danger">{{item.currently_issued}}</b-td>
                        <b-td class="text-right table-success">
                            <b>{{item.diff}}</b>
                        </b-td>
                        <b-td class="text-right">
                            <b>{{item.anzahl}}</b>
                        </b-td>
                        <b-td>{{item.archivnr}}</b-td>
                        <b-td class="text-right">{{item.preis}} €</b-td>
                        <b-td class="text-center">
                            <template v-if="item.geliehen == 1">
                                <font-awesome-icon icon="check" />
                            </template>
                            <template v-else>
                                <font-awesome-icon icon="minus" />
                            </template>
                        </b-td>
                        <b-td>{{item.geliehen_von}}</b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </template>
    </section>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import { ApiFactory } from "@/api/ApiFactory.js";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";

import "./NotenartDetail.scss";

const NotenverwaltungApi = ApiFactory.get("notenverwaltung");

export default {
    name: "NotenartDetail",
    props: ["id", "refresh"],
    mixins: [CommonView],
    components: {
        CenteredMessage
    },
    data() {
        return {
            api: NotenverwaltungApi
        };
    },
    watch: {
        refresh: {
            handler() {
                this.fetch();
            }
        }
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await this.api.getNotenart(this.id);
            if (response.ok) {
                this.items = response.json.collection;
            }
            this.busy = false;
        }
    }
};
</script>